import { createStaticPropsGetter,Page } from "../libs/pages";

export const getStaticProps = createStaticPropsGetter("cookies");

export default Page;
